export default "__VITE_ASSET__CFXdNLWZ__"